import { render } from "./CaptureTips.vue?vue&type=template&id=343357be&scoped=true"
import script from "./CaptureTips.vue?vue&type=script&lang=js"
export * from "./CaptureTips.vue?vue&type=script&lang=js"

import "./CaptureTips.vue?vue&type=style&index=0&id=343357be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343357be"]])

export default __exports__